import { useEffect, useState } from "react";
import axios from "axios";

function AdminServiceApproval() {
  const [installerServices, setInstallerServices] = useState([]);
  const [vendorServices, setVendorServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [processing, setProcessing] = useState({}); // track per-service processing

  const fetchPending = async () => {
    setLoading(true);
    setMessage("");
    try {
      const [installersRes, vendorsRes] = await Promise.all([
        axios.get("/api/admin/installer-services/pending"),
        axios.get("/api/admin/vendor-services/pending"),
      ]);

      setInstallerServices(installersRes.data?.data || []);
      setVendorServices(vendorsRes.data?.data || []);
    } catch (err) {
      console.error(err);
      setMessage("⚠️ Failed to fetch pending services. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPending();
  }, []);

  const handleApproval = async (type, id, action) => {
    setProcessing((prev) => ({ ...prev, [id]: true }));
    try {
      const confirmAction = window.confirm(`Are you sure you want to ${action} this ${type} service?`);
      if (!confirmAction) return;

      await axios.put(`/api/admin/${type}-services/${id}/${action}`);

      setMessage(`✅ ${type.charAt(0).toUpperCase() + type.slice(1)} service ${action}d successfully!`);
      fetchPending();
    } catch (err) {
      console.error(err);
      setMessage(`❌ Failed to ${action} ${type} service.`);
    } finally {
      setProcessing((prev) => ({ ...prev, [id]: false }));
    }
  };

  if (loading) return <p style={{ textAlign: "center" }}>Loading pending services...</p>;

  const renderCard = (service, type) => (
    <div key={service._id} style={styles.card}>
      {service.image && <img src={service.image} alt={service.name || service.businessName} style={styles.image} />}
      <h4>{service.name || service.businessName}</h4>
      {type === "installer" && (
        <>
          <p><b>Location:</b> {service.location}</p>
          <p><b>Experience:</b> {service.yearsExperience} years</p>
        </>
      )}
      {type === "vendor" && (
        <>
          <p><b>Location:</b> {service.location}</p>
          <p><b>Price:</b> ₦{service.price}</p>
        </>
      )}
      <p>{service.description}</p>
      <div style={styles.btnGroup}>
        <button
          style={{ ...styles.btn, background: "#28a745" }}
          onClick={() => handleApproval(type, service._id, "approve")}
          disabled={processing[service._id]}
        >
          {processing[service._id] ? "Processing..." : "✅ Approve"}
        </button>
        <button
          style={{ ...styles.btn, background: "#dc3545" }}
          onClick={() => handleApproval(type, service._id, "reject")}
          disabled={processing[service._id]}
        >
          {processing[service._id] ? "Processing..." : "❌ Reject"}
        </button>
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>🛠 Admin Service Approval Dashboard</h1>

      {message && (
        <p style={{ ...styles.alert, backgroundColor: message.startsWith("✅") ? "#e6ffee" : "#ffe6e6", color: message.startsWith("✅") ? "#006600" : "#b30000" }}>
          {message}
        </p>
      )}

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Pending Installer Services</h2>
        {installerServices.length === 0 ? <p>No pending installer services.</p> : installerServices.map((s) => renderCard(s, "installer"))}
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Pending Vendor Services</h2>
        {vendorServices.length === 0 ? <p>No pending vendor services.</p> : vendorServices.map((s) => renderCard(s, "vendor"))}
      </section>
    </div>
  );
}

const styles = {
  container: { maxWidth: 900, margin: "2rem auto", padding: "2rem", background: "#fdfdfd", borderRadius: "1rem", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", fontFamily: "Poppins, sans-serif" },
  title: { textAlign: "center", color: "#ff6411", marginBottom: "2rem" },
  section: { marginBottom: "3rem" },
  sectionTitle: { color: "#333", borderBottom: "2px solid #ff6411", paddingBottom: "0.5rem" },
  card: { background: "#fff", borderRadius: "10px", padding: "1rem", margin: "1rem 0", boxShadow: "0 2px 10px rgba(0,0,0,0.05)" },
  image: { width: "100%", height: 180, objectFit: "cover", borderRadius: "8px" },
  btnGroup: { display: "flex", gap: "1rem", marginTop: "1rem" },
  btn: { flex: 1, padding: "10px", border: "none", borderRadius: "6px", color: "#fff", fontWeight: 600, cursor: "pointer" },
  alert: { textAlign: "center", padding: "10px", borderRadius: "6px", marginBottom: "1rem", fontWeight: 500 },
};

export default AdminServiceApproval;

